import ApiRequest from "../index"

const mediasRequest = {
  getMedias: async () => ApiRequest.get("/v2/lojinha/medias/list"),
  putMedias: async data => ApiRequest.put("/v2/lojinha/medias/update", { ...data })
}

export default mediasRequest
